import React from 'react'

import type { MonthTitleProps } from './types'

export default function MonthTitle({ monthDate }: MonthTitleProps) {
  return (
    <span className="react-datepicker__current-month">
      {monthDate?.toLocaleString('en-US', {
        month: 'short',
        year: 'numeric',
      })}
    </span>
  )
}
